import React, { useState, useEffect, useRef } from "react";
import CommonCard from "../common/commonCard";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import FormCard from "../common/formCard";
import TimeLine from "../common/timeline";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Footer from "../common/footer";
import MessagePopUp from "../common/messagePopUp";
import { GetIncidentResponsibleService } from "../../Services/incidentService";
import { PatchNotificationViewService } from "../../Services/notificationService";
import Spinner from 'react-bootstrap/Spinner';
import { PatchIncidentService } from "../../Services/incidentService";
import CustomTable from "../common/table";
import { formatToSpanishTimeZone } from "../../utils/formatDate";
import { useTranslation } from "react-i18next";


const IncidentComponent = () => {
  const [t] = useTranslation("incidents")
  const [expanded, setExpanded] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPlayPopup, setShowPlayPopup] = useState(false);
  const location = useLocation();
  const [estadoCaso, setEstadoCaso] = useState("pendiente"); // Valor inicial, cámbialo según tu necesidad
  const [isEstadoCasoChanged, setIsEstadoCasoChanged] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [key, setKey] = useState(Date.now()); // Nueva clave estado
  const [loading, setLoading] = useState(true);
  const [docsFromIncident, setDocsFromIncidents] = useState([]);
  const [changeData, setChangeData] = useState(false);


  const { id } = useParams();
  const navigate = useNavigate();
  // Crear refs para almacenar el valor previo de key e itemData
  const prevKeyRef = useRef();
  const prevItemDataRef = useRef();

  useEffect(() => {
    // Actualizar el ref cuando el componente se actualiza
    prevKeyRef.current = key;
    prevItemDataRef.current = itemData;
  });

  useEffect(() => {
    const getIncident = async () => {
      setLoading(true)
      try {
        setItemData([])
        const incidentData = await GetIncidentResponsibleService(id);
        setItemData(incidentData[0]);
        if (incidentData[0].stateId === "65e4955b-9814-400a-a3b8-0331f9d418dd") {
          setShowPopup(true);
          await PatchIncidentService(id);

          navigate(`/incident/${id}`);

        }
        await PatchNotificationViewService(id);
        setLoading(false)

      } catch (error) {
        console.error(error); // Error al cargar, también actualizar estado
        setLoading(false)
        navigate('/access-denied');

      }
    };
    getIncident();
  }, [location, changeData]);


  useEffect(() => {
    setIsEstadoCasoChanged(true);
  }, [estadoCaso]);

  useEffect(() => {
    setIsEstadoCasoChanged(false); // Restablecer isEstadoCasoChanged a false cuando se monta el componente
  }, []);

  const downloadDoc = (mimeType, fileData, incidentKey) => {
    const blob = b64toBlob(fileData, mimeType);
    const downloadLink = document.createElement("a");
    const fileName = `${incidentKey}_${t("pdfIncident.documentation")}`;
    downloadLink.download = fileName;
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.click();
  };

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  const handleButtonMessageClick = () => {
    setShowPopup(false);
  };

  const handleButtonAudioPopUpMessageClick = () => {
    setShowPlayPopup(false);
  };

  //Formatemos los datos de incident para obtener todos los docs (Activities docs + incident doc).
  useEffect(() => {

    setDocsFromIncidents([]);
    let docsActivities = [];

    if (itemData.incidentActivities) {
      docsActivities = itemData.incidentActivities
        .filter(activity => activity.fileData && activity.fileName)
        .map(activity => {
          return {
            ...activity,
            incidentKey: itemData.incidentKey,
            createdAt: formatToSpanishTimeZone(activity.createdAt)
          };
        });
    }

    if (itemData.fileData != null) {
      let docFromIncident = {
        createdAt: itemData.createdAt,
        fileName: itemData.fileName,
        fileData: itemData.fileData,
        incidentActivityType: `${t("consultIncident.activityCreation")}`,
        incidentKey: itemData.incidentKey

      }

      docsActivities.push(docFromIncident);

    }

    setDocsFromIncidents(docsActivities);


  }, [itemData, changeData]);

  const columnHeaders = [
    `${t("incidentActivityTable.createdAt")}`,
    `${t("incidentActivityTable.fileName")}`,
    `${t("incidentActivityTable.incidentActivityType")}`,
  ];

  const fieldsToShow = [
    "createdAt",
    "fileName",
    "incidentActivityType"
  ];

  const optionArrays = [
    []
  ];

  return (
    <div key={key}>
      <MessagePopUp
        show={showPopup}
        handleClose={() => setShowPopup(false)}
        title={t("incidentMessages.incidentRecievedTitle")}
        textBody={t("incidentMessages.incidentRecievedText")}
        buttonText={t("incidentMessages.acceptButton")}
        onClickButton={handleButtonMessageClick}
      />
      <MessagePopUp
        show={showPlayPopup}
        handleClose={() => setShowPlayPopup(false)}
        title={t("incidentAudioPopup.title")}
        textBody={
          itemData.audio ? (
            <audio controls controlsList="nodownload" className="mt-2 mb-2">
              <source src={`${itemData.audio}`} type="audio/wav" />
              {t("incidentAudioPopup.noSupport")}
            </audio>
          ) : (
            <p>{t("incidentAudioPopup.noAudioAvailable")}</p>
          )
        }
        buttonText={t("incidentAudioPopup.acceptButton")}
        onClickButton={handleButtonAudioPopUpMessageClick}
      />
      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={() => setChangeData(!changeData)}
      />

      {/* cargando spinner  */}
      <Modal
        show={loading}
        backdrop="static"
      >
        <Modal.Body>
          <Container>
            <div className="common-card-loading-container">

              <div className="common-card-loading-popup custom-shadow-bold rounded-border-px">
                <Spinner animation="border" className="spinner-big m-auto" />
                <div className="common-card-loading-popup-text font-bold color-custom-secondary mt-4">{t("incidentMessages.loadingData")}</div>
              </div>
            </div>
          </Container>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <Row>
          <Col
            className='d-flex'
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "2%" : "4%"}`,
            }}
          >
            <Sidebar
              expanded={expanded}
              setExpanded={setExpanded}
              selected={"Casos"}
            />
          </Col>
          <Col
            className='custom-content-wrapper'
            style={{
              marginLeft: `0.5%`,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "86%" : "93%"}`,
            }}
          >
            <Row>
              {/* Columna principal para los Col md={8} */}
              <Col md={7}>
                <Row>
                  {/* Primer CommonCard */}
                  <Col md={12}>
                    <CommonCard
                      title={t("dataForm.title")}
                      icon={"FaDatabase"}
                      downloadIncident={itemData.file}
                      incidentId={itemData.incidentKey}
                      incidentData={itemData}
                    >
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.company")}
                            text={itemData.company}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.workPlace")}
                            type={"text"}
                            text={itemData.workPlace ? itemData.workPlace : "---"}
                            readOnly={true}
                            key={itemData.workPlace}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.createdAt")}
                            text={itemData.createdAt}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.category")}
                            text={itemData.category}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>

                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.informantType")}
                            type={"text"}
                            text={itemData.informantType}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.userName")}
                            text={
                              itemData.userName
                            }
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    </CommonCard>
                    <CommonCard
                      title={t("dataForm.title2")}
                      icon={"FaCircleInfo"}
                    >
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.titleIncident")}
                            text={itemData.title}
                            type={"textarea"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={t("dataForm.incidentDate")}
                            text={itemData.incidentDate}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        {itemData?.customQuestions?.map((question, index) =>
                          <Col md={6}>
                            <FormCard
                              title={question.question}
                              text={question.response}
                              type={"text"}
                              readOnly
                            />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormCard
                            title={t("dataForm.description")}
                            text={itemData.description}
                            type={"textarea"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <div className="text-center mt-4 d-flex ">
                        {itemData?.fileData ?
                          <Button
                            variant="secondary custom-shadow"
                            className="custom-button-secondary m-auto background-gradient"
                            disabled={!itemData?.fileData}
                            onClick={() =>
                              downloadDoc(itemData.fileMimeType, itemData.fileData, itemData.incidentKey)
                            }
                          >
                            {t("dataForm.downloadDocButton")}
                          </Button>
                          :
                          null
                        }
                        {itemData?.audio ?
                          <Button
                            variant="secondary custom-shadow"
                            className="custom-button-secondary m-auto background-gradient"
                            disabled={!itemData?.audio}
                            onClick={() =>
                              setShowPlayPopup(true)
                            }
                          >
                            {t("dataForm.playAudioButton")}
                          </Button>
                          :
                          null
                        }
                      </div>

                    </CommonCard>
                  </Col>
                  {/* Segundo CommonCard */}

                  {/* Tercer CommonCard */}
                  <Col md={12}>
                    <CommonCard title={t("incidentActivityTable.title")} icon={"FaFileDownload"}>
                      {itemData &&
                        itemData.incidentActivities &&
                        itemData.incidentActivities.length > 0 ? (
                        <CustomTable
                          columnHeaders={columnHeaders}
                          fieldsToShow={fieldsToShow}
                          data={docsFromIncident}
                          optionArrays={optionArrays}
                          defaultFilterField={'createdAt'}
                          defaultFilterDirection={'desc'}
                          loading={loading}
                          downloadButton
                          editButton={false}
                          displayFilter={false}
                        />
                      ) : (
                        <p></p>
                      )}

                    </CommonCard>
                  </Col>
                </Row>
              </Col>
              {/* Columna principal para el Col md={4} */}
              <Col md={5}>
                <Row>
                  <Col md={12}>
                    <CommonCard title={t("situationForm.title")} icon={"FaDatabase"}>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={t("situationForm.limitDateAd")}
                            text={itemData.limitDateAd}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={t("situationForm.limitDateRes")}
                            text={itemData.limitDateRes}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormCard
                            title={t("situationForm.state")}
                            text={itemData.state}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                        <Col md={6}>
                          <FormCard
                            title={t("situationForm.responsible")}
                            text={itemData.responsible}
                            type={"text"}
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    </CommonCard>
                  </Col>

                  {/* Tercer CommonCard más pequeño */}
                  <Col md={12}>
                    <CommonCard
                      title={t("histoyTable.title")}
                      icon={"FaClock"}
                      actividad={
                        itemData.stateId !== "ac41947f-2b62-45bc-a156-4774846c58a0" && itemData.stateId !== "ce3e3338-e90b-4999-82f7-aa965824a62f" ? "responsible" : false
                      }
                    >
                      <Row>
                        {itemData &&
                          itemData.incidentActivities &&
                          itemData.incidentActivities.length > 0 ? (
                          <TimeLine items={itemData.incidentActivities} />
                        ) : (
                          <p>{t("histoyTable.noActivities")}</p>
                        )}
                      </Row>
                    </CommonCard>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Footer />
          </Col>
        </Row>
      </Container >
    </div >
  );
};

export default IncidentComponent;
